module.exports={
"header.industry.mall":`業界モール`,
"header.home":`ホーム`,
"header.solutions.apps":`業界CRM`,
"header.learning.center":`学習センター`,
"header.partner.portal":`パートナーポータル`,
"header.pricing.plan":`製品価格`,
"header.my.orders":`マイオーダー`,
"header.login.cloudcc":`CloudCCログイン`,
"header.logout":`ログアウト`,
"header.login.industry.mall":`業界モールログイン`,
"header.search":`検索`,
"header.congrats.formal.partner":`おめでとうございます！正式パートナーになりました`,
"header.logout.success":`ログアウト成功`,
"footer.scan.follow":`QRコードをスキャンして公式アカウントをフォロー`,
"footer.quick.links":`クイックリンク`,
"footer.why.cloudcc":`なぜCloudCC`,
"footer.business.platform":`ビジネスプラットフォーム`,
"footer.integration":`統合`,
"footer.paas.platform":`PaaSプラットフォーム`,
"footer.case.center":`ケースセンター`,
"footer.data.security":`データセキュリティ`,
"footer.gdpr.compliance":`GDPR準拠`,
"footer.service.agreement":`サービス契約`,
"footer.privacy.statement":`プライバシーステートメント`,
"footer.app.permissions":`アプリ権限`,
"footer.products.prices":`製品・価格`,
"footer.sales.cloud":`セールスクラウド`,
"footer.customer.service.cloud":`サービスクラウド`,
"footer.field.service.cloud":`フィールドサービスクラウド`,
"footer.marketing.cloud":`マーケティングクラウド`,
"footer.partner.cloud":`パートナークラウド`,
"footer.project.cloud":`プロジェクトクラウド`,
"footer.social.cloud":`ソーシャルクラウド`,
"footer.platform.cloud":`プラットフォームクラウド`,
"footer.mobile.terminal":`モバイル端末`,
"footer.versions.prices":`バージョン・価格`,
"footer.industry.solutions":`業界ソリューション`,
"footer.manufacturing":`製造業`,
"footer.education.training":`教育・研修`,
"footer.it.hightech":`IT・ハイテク`,
"footer.city.operation":`都市運営`,
"footer.finance.industry":`金融業界`,
"footer.medical.devices":`医療機器`,
"footer.tourism.industry":`観光業界`,
"footer.legal.industry":`法律業界`,
"footer.service.support":`サービス・サポート`,
"footer.partners":`パートナー`,
"footer.partner.support":`パートナーサポート`,
"footer.help.center":`ヘルプセンター`,
"footer.resource.center":`リソースセンター`,
"resource.solutions.customer.service.cloud":`サービスクラウド`,
"resource.solutions.field.service.cloud":`フィールドサービスクラウド`,
"resource.solutions.project.cloud":`プロジェクトクラウド`,
"resource.solutions.partner.cloud":`パートナークラウド`,
"resource.solutions.business.cloud":`ビジネスクラウド`,
"resource.solutions.profit.cloud":`プロフィットクラウド`,
"resource.solutions.platform.cloud":`プラットフォームクラウド`,
"navigation.banner.ai.empower":`AI搭載1日業界ソリューションCRM作成`,
"navigation.banner.zero.tech.threshold":`技術的敷居なし`,
"navigation.banner.price.autonomy":`価格自主性`,
"navigation.banner.permanent.profit.sharing":`永続的利益分配`,
"navigation.banner.saas.entrepreneurship":`SaaS起業の新時代を開始`,
"navigation.banner.experience.now":`今すぐ体験`,
"home.install.stats":`合計{0}個の業界ソリューション製品。最近{1}回インストールされました。`,
"home.stats.total":`合計`,
"home.stats.industry.products":`個の業界ソリューション製品。総インストール数`,
"home.stats.times":`回。`,
"footer.about.us":`会社概要`,
"footer.company.introduction":`会社紹介`,
"footer.company.news":`企業ニュース`,
"footer.management.team":`経営チーム`,
"footer.corporate.culture":`企業文化`,
"footer.development.history":`発展の歴史`,
"footer.qualifications.honors":`資格・栄誉`,
"footer.brand.culture":`ブランド文化`,
"footer.join.cloudcc":`CloudCCに参加`,
"footer.contact.us":`お問い合わせ`,
"footer.app.download":`アプリダウンロード`,
"footer.scan.qrcode":`QRコードをスキャンしてモバイルアプリをダウンロード`,
"footer.enter.mobile.store":`モバイルストアに入ってモバイルアプリをダウンロード`,
"footer.telecom.license":`付加価値電気通信事業許可証：北京B2-20170892`,
"footer.copyright":`© 著作権：北京神州雲動科技股份有限公司`,
"footer.developer":`開発者：北京神州雲動科技股份有限公司 全権利保有`,
"footer.icp.registration":`北京ICP第09016255号`,
"footer.icp.certificate":`北京ICP証110683号`,
"footer.public.security":`北京公安ネットワークセキュリティ第110108008174号`,
"agreement.license":`ライセンス契約`,
"agreement.i.agree":`同意します`,
"agreement.enterprise.agreement":`企業（または個人）CloudCCマーケットプレイス契約`,
"agreement.i.agree.cloudcc":`CloudCCの`,
"agreement.privacy.policy":`プライバシーポリシー`,
"agreement.and":`および`,
"agreement.terms.of.service":`利用規約`,
"agreement.apply.partner":`パートナーとして申請`,
"agreement.must.agree.license":`CloudCCライセンス契約に同意する必要があります`,
"agreement.must.agree.enterprise":`企業または個人CloudCCマーケットプレイス契約に同意する必要があります`,
"label.appstore.UntilMaturity.time":`有効期限までの残り時間`,
"label.appstore.list.payments":`当社の製品をご購入いただくと、お支払い方法がここに表示されます。`,
"label.appstore.duedate":`支払期日`,
"label.appstore.Pay":`支払い`,
"label.appstore.enterAddress":`詳細住所を入力してください。`,
"label.appstore.country":`国`,
"label.appstore.Update.profile":`プロフィール更新`,
"label.appstorePleaseEnter":`入力してください`,
"label.appstore.useremail":`ユーザーメール`,
"label.appstore.Enabled.quantity":`有効化数`,
"label.appstore.Pay.gateway":`安全で信頼できる決済ゲートウェイ`,
"label.appstore.year":`年`,
"label.appstore.Version.price":`バージョンと価格`,
"label.appstore.cancel":`キャンセル`,
"label.appstore.selectMonth":`月を選択してください。`,
"label.appstore.Change.new.address":`この請求先住所を使用するすべての既存注文が新しい住所に変更されます。`,
"label.appstore.noAccess":`考えられる理由：URLが間違っているか、アクセス権限がない可能性があります。`,
"label.appstore.MonthlyAmount":`月額`,
"label.appstore.TechnicalDetails":`技術詳細`,
"label.appstore.Please.enter.the.content":`内容を入力してください`,
"label.appstore.invoice":`請求書`,
"home.explore.hot.categories":`人気カテゴリを探索`,
"home.use.appexchange":`AppExchangeでCloudCCを拡張`,
"home.appexchange.description":`AppExchangeは、CloudCCデジタルワークフォースプラットフォームを拡張するための9,000以上の事前構築およびカスタマイズ可能なアプリケーションを備えた、主要な企業クラウドマーケットプレイスです。1,300万回以上のインストールと157,000件のユーザーレビューを持つ成熟したエコシステムで、お客様独自のビジネスニーズに最適なソリューションを見つけるお手伝いをします。現在、AgentExchangeにより、最適なAgentforceパートナーソリューションを活用してAIエージェントを迅速に構築できます。`,
"home.view.all":`すべて表示`,
"message.no.data":`データが見つかりません`,
"message.load.failed":`データの読み込みに失敗しました`,
"message.no.more.data":`これ以上データはありません`,
"applist.sponsored.solutions":`推奨業界ソリューション`,
"applist.today.trends":`最新業界ソリューション`,
"applist.view.more":`もっと見る`,
"industry.education":`教育業界`,
"industry.manufacturing":`製造業界`,
"industry.it":`IT業界`,
"industry.finance":`金融業界`,
"industry.medical":`医療業界`,
"resource.data.sheet":`データシート`,
"resource.customer.review":`顧客レビュー`,
"resource.case.study":`ケーススタディ`,
"resource.whitepaper":`ホワイトペーパー`,
"resource.webinar":`ウェビナー`,
"resource.custom.guide":`カスタムガイド`,
"resource.solutions.sales.cloud":`セールスクラウド`,
"resource.solutions.marketing.cloud":`マーケティングクラウド`,
"resource.solutions.service.cloud":`サービスクラウド`,
"resource.solutions.office.cloud":`オフィスクラウド`,
"resource.solutions.hr":`人事`,
"resource.solutions.project.management":`プロジェクト管理`,
"resource.solutions.other":`その他`,
"resource.category.custom.component":`カスタムコンポーネント`,
"resource.category.custom.class":`カスタムクラス`,
"resource.category.scheduled.class":`スケジュールクラス`,
"resource.category.trigger":`トリガー`,
"resource.category.client.script":`クライアントスクリプト`,
"resource.industry.automotive":`自動車`,
"resource.industry.consumer.goods":`消費財`,
"resource.industry.communication":`通信`,
"resource.industry.high.end.manufacturing":`ハイエンド製造`,
"resource.industry.semiconductor":`半導体チップ`,
"resource.industry.mechanical.equipment":`機械設備`,
"resource.industry.heavy.manufacturing":`重工業製造`,
"resource.industry.ai.computing":`AI・コンピューティングパワー`,
"resource.industry.internet":`インターネット`,
"resource.industry.financial.investment":`金融投資`,
"resource.industry.financing.guarantee":`融資保証`,
"resource.industry.financial.leasing":`金融リース`,
"resource.industry.insurance":`保険`,
"resource.industry.wealth.management":`資産管理`,
"resource.industry.medical.devices":`医療機器/IVD`,
"resource.industry.pharmaceutical":`製薬`,
"resource.industry.health.elderly.care":`健康・高齢者ケア`,
"resource.industry.medical.service.solution":`医療サービス`,
"resource.industry.education.training":`教育・研修`,
"resource.industry.k12":`K12`,
"resource.industry.energy.chemical":`エネルギー・化学`,
"resource.industry.nonferrous.metals":`非鉄金属`,
"resource.industry.steel":`鉄鋼`,
"resource.industry.park.real.estate":`パーク・不動産`,
"resource.industry.lawyer":`法律サービス`,
"resource.industry.enterprise.service":`企業サービス`,
"resource.industry.media.tourism":`メディア・観光`,
"resource.industry.other":`その他`,
"appdetail.price.per.month":`/人/月`,
"appdetail.apply.trial.portal":`体験客户门户`,
"appdetail.apply.trial":`体験CRM`,
"appdetail.apply.demo":`デモ申請`,
"appdetail.buy.install":`購入・インストール`,
"appdetail.app.info":`アプリケーション基本情報`,
"appdetail.feature.intro":`機能紹介`,
"appdetail.highlights":`ハイライト`,
"appdetail.rating":`評価`,
"appdetail.listing.time":`掲載時間`,
"appdetail.latest.release":`最新リリース`,
"appdetail.supported.terminals":`対応端末`,
"appdetail.version":`バージョン`,
"appdetail.app.type":`アプリケーションタイプ`,
"appdetail.compatibility":`互換性`,
"appdetail.app.details":`アプリケーション詳細`,
"appdetail.more.details":`詳細情報`,
"appdetail.more.from.provider":`プロバイダーからのその他の製品`,
"appdetail.provider.details":`プロバイダー詳細`,
"appdetail.pricing.details":`価格詳細`,
"appdetail.payment.required":`このソリューションを使用するには支払いが必要です。`,
"appdetail.basic.version":`基本版`,
"appdetail.minimum.price":`最低開始価格`,
"appdetail.provided.by":`{0}により提供`,
"appdetail.cloudcc.industry.solution":`CloudCC業界ソリューション`,
"message.no.matches.found":`一致するものが見つかりませんでした。別の検索語句をお試しください。`,
"header.access.partner.crm":`18年間の深耕、数百のエコシステムパートナーの経験を結集し、30の細分化された業界向け専用CRMを構築`,
"header.industry.demo": `登録不要！今すぐ30の細分化された業界向けCRMデモシステムに入り、AIとビッグデータによる業界ノウハウを100％リアルに体験してください！`,
"header.login.your.crm":`CRMシステムにログイン`,
"appdetail.industry":`所属業界`,
"appdetail.developer":`開発者`,
"appdetail.official.website":`公式ウェブサイト`,
"appdetail.contact.email":`連絡先メール`,
"appdetail.contact.phone":`連絡先電話`,
"appdetail.confirm.purchase":`購入を確認しますか？`,
"appdetail.tip":`ヒント`,
"appdetail.confirm":`確認`,
"appdetail.cancel":`キャンセル`,
"appdetail.purchase.success":`購入成功`,
"appdetail.already.purchased":`この商品は既に購入済みです`,
"appdetail.limited.time.free":`期間限定無料`,
"appdetail.ai.building.solution":`AIがソリューションを構築中です`,
"appdetail.build.failed":`構築失敗`,
"appdetail.ai.building.env":`AIが試用環境を構築中です。完了すると自動的に環境に入り、メールでログイン情報を受信します。`,
"appdetail.ai.building.estimate":`目安：2〜10分で完了`,
"appdetail.build.problem":`構築プロセス中に問題が発生しました。再試行するかカスタマーサービスにお問い合わせください`,
"appdetail.building":`構築中...`,
"appdetail.rebuild":`再構築`,
"appdetail.trial.email.title":`試用申請`,
"appdetail.trial.email.content":`メールアドレスを入力してください。このメールアドレスで試用アカウントを作成し、ログイン情報もメールで受信します`,
"appdetail.trial.email.placeholder":`メールアドレスを入力してください`,
"appdetail.trial.email.validation.required":`メールアドレスを入力してください`,
"appdetail.trial.email.validation.format":`正しいメール形式を入力してください`,
"appdetail.trial.email.validation.exists":`このメールは既に存在します。別のメールを使用してください`,
"appdetail.trial.email.exists":`このメールは既に存在します。別のメールを使用してください`,
"appdetail.trial.email.check.failed":`メール確認に失敗しました。再試行してください`,
"appdetail.trial.email.success":`メール確認成功、試用情報が送信されました`,
"appdetail.trial.email.error":`メール確認に失敗しました。再試行してください`,
"label.appstore.priceNumber.jian":`単価*数量*(残り時間-割引月)=金額`,
"label.appstore.payTime":`支払い時間`,
"label.appstore.industry":`業界`,
"label.appstore.Premium.offer":`年間注文で大幅割引を獲得。5年サービス購入で20ヶ月無料。`,
"label.appstore.nopay":`未払い`,
"label.appstore.readMore":`続きを読む`,
"label.appstore.prease.enter.emailAddress":`メールアドレスを入力してください。`,
"label.appstore.Compare.details":`注文詳細を比較`,
"label.appstore.Version.upgrade":`バージョンアップグレード`,
"label.appstore.Request.form":`リクエストフォーム`,
"label.appstore.ordeDetail":`注文詳細`,
"label.appstore.enter.correct.email":`正しいメールアドレスを入力してください。`,
"label.appstore.function":`機能`,
"label.appstore.accountType":`アカウントタイプ`,
"label.appstore.Ordering.plan":`注文プラン`,
"label.appstore.cardCode":`クレジットカードコード`,
"label.appstore.Not.yet.purchased":`まだ購入していません`,
"label.appstore.Order.now":`今すぐ注文`,
"label.appstore.Paymen.method":`支払い方法`,
"label.appstore.T&C":`利用規約`,
"label.appstore.Subtotal":`小計`,
"label.appstore.One.year.discount":`1年割引`,
"label.appstore.TotalQuantity":`総数量`,
"label.appstore.PaidAmount":`支払い金額`,
"label.appstore.Received":`リクエストを受信しました。すぐにご連絡いたします。`,
"label.appstore.Amount.proportion":`金額は比例計算されます`,
"label.appstore.enterEms":`郵便番号を入力してください。`,
"label.appstore.terms":`支払い条件`,
"label.appstore.change":`変更`,
"label.appstore.place.order":`注文提出`,
"label.appstore.Ordinary.account":`一般アカウント`,
"label.appstore.UntilMaturity":`有効期限まで{0}ヶ月の金額`,
"label.appstore.changeBilling":`請求先住所をクレジットカード住所として使用`,
"label.appstore.newly.added":`新規追加`,
"label.appstore.buyDuration":`購入期間`,
"label.appstore.change.payoptions":`新しい支払いオプションを選択`,
"label.appstore.redirect":`支払いまたはPayPalアカウント作成のためのログインページにリダイレクトされ、支払い方法を更新します。`,
"label.appstore.quickTime":`おっと！時間が経つのは早いですね...`,
"label.appstore.enterSurname":`姓を入力してください。`,
"label.appstore.quantity":`数量`,
"label.Version.change.succeeded":`バージョン変更成功`,
"label.appstore.please.fill.city":`都市を入力してください。`,
"label.appstore.contact.phone":`+1 (800) 820-6983`,
"label.appstore.payment.method.other":`その他の支払い方法`,
"label.appstore.buy.year.Discount4":`4年購入で14ヶ月割引`,
"label.appstore.Add.function":`Lightningにサービスクラウドのフィールドサービスとカスタマーサービス機能を追加`,
"label.appstore.Insufficient.privileges":`権限不足`,
"label.appstore.View.order":`注文表示`,
"label.appstore.FillQuantity":`数量を入力してから続行してください`,
"label.appstore.ordernum":`注文番号`,
"label.appstore.Upgradeable":`アップグレード可能`,
"label.appstore.Remaining.licenses":`残りライセンス数`,
"label.appstore.Renewal.succeeded":`更新成功`,
"label.appstore.add.User":`ユーザー追加`,
"label.appstore.SeeMore":`もっと見る`,
"label.appstore.payment.gateway":`決済ゲートウェイ`,
"label.appstore.enter.VerificationCode":`カード確認コードを入力してください`,
"label.appstore.renew":`更新`,
"label.appstore.Terms.of.service":`利用規約`,
"label.appstore.Billing.updated":`請求先住所が正常に更新されました。今後この住所に関連するすべての注文請求書は新しい住所を使用します。`,
"label.appstore.selectCity":`都市を選択してください`,
"label.appstore.buy.year.Discount":`1年購入で2ヶ月割引`,
"label.appstore.AnnualOrder":`年間注文`,
"label.appstore.change.version":`バージョン変更`,
"label.appstore.EnjoyAuthority":`（セールスクラウド機能と割り当て者管理権限を享受）`,
"label.appstore.HideFeatures":`機能とアドオンを非表示`,
"label.appstore.please.select.time":`時間を選択してください`,
"label.appstore.idiot.proof":`安全で信頼できる`,
"label.appstore.notPayment":`支払い方法が見つかりません`,
"label.appstore.Manage.subscriptions":`すべての購読<a style="color: #075bd5" href="https://www.cloudcc.com/">製品</a>を一箇所で管理。当社の製品を購入すると、ここに表示されます。`,
"label.appstore.buy.year.Discount5":`5年購入で20ヶ月割引`,
"label.appstore.usd.annu":`/ユーザー/月（年間支払い）`,
"label.appstore.Transaction.rejection":`取引が拒否されました。詳細については銀行にお問い合わせください。`,
"label.appstore.upgrade":`アップグレード`,
"label.appstore.Go.to.order":`注文へ移動`,
"label.appstore.Amount .paid.now":`現在支払う金額`,
"label.appstore.TransferOrder":`注文転送`,
"label.appstore.Remaining.duration":`残り期間`,
"label.appstore.orderId":`注文ID`,
"label.appstore.AfterAdding":`追加後`,
"label.appstore.update":`更新`,
"label.appstore.corporate.name":`会社名`,
"label.appstore.Please.renew":`有効期限の1ヶ月前にシステムで更新してください。通常の使用に影響しないようにするためです。`,
"label.appstore.go":`へ`,
"label.appstore.FlagshipEdition":`フラッグシップ版`,
"label.appstore.productName":`製品名`,
"label.appstore.continue1":`続行`,
"label.appstore.back.crm":`CRMに戻る`,
"label.appstore.term.of.validity":`有効期間`,
"label.appstore.please.fill.MM":`MMを入力してください`,
"label.appstore.Cancelled":`キャンセル済み`,
"label.appstore.click":`クリック`,
"label.appstore.please.fill.country":`国を入力してください`,
"label.appstore.Application.recommendation":`公式アプリケーション推奨`,
"label.appstore.user.month":`{0}/ユーザー/月`,
"label.appstore.TransactionIDs":`取引ID`,
"label.appstore.nofindbBlling":`請求先住所が見つかりません`,
"label.appstore.Use.other.methods":`その他の方法を使用`,
"label.appstore.ViewOrderDetail":`注文詳細表示`,
"label.appstore.ApplicationVersion":`アプリケーションバージョン`,
"label.select.country.first":`まず国/地域を選択してください`,
"label.appstore.Successfully.ordered":`スタンダード版プランの注文が成功しました。`,
"label.appstore.operation":`操作`,
"label.appstore.licensesTotal":`総ライセンス数`,
"label.appstore.enterName":`名前を入力してください。`,
"label.appstore.time.year":`時間（年）`,
"label.appstore.Receive.discount":`年間注文で大幅割引を獲得`,
"label.appstore.workTime":`8時間勤務 - 月曜日から金曜日`,
"label.appstore.Payment.failed":`購入支払いに失敗しました。`,
"label.appstore.please.fill.YY":`YYを入力してください`,
"label.appstore.Billing.information":`請求情報`,
"label.appstore.UserMonth":`{}/ユーザー/月`,
"label.appstore.Wrong.mobile":`携帯電話番号の形式が正しくありません。`,
"label.appstore.enddate":`終了日`,
"label.appstore.buy.products":`当社の製品を購入したい場合は、お問い合わせください。`,
"label.appstore.user":`ユーザー`,
"label.appstore.ems":`郵便番号`,
"label.appstore.month":`月`,
"label.appstore.charge":`料金`,
"label.appstore.sign":`これはコンピューター生成の請求書で、署名は不要です。`,
"label.appstore.ConfirmOrder":`注文確認`,
"label.appstore.Address.and.others":`請求先住所・その他情報`,
"label.appstore.EnterpriseEdition":`エンタープライズ版`,
"label.appstore.buy.year.Discount3":`3年購入で9ヶ月割引`,
"label.appstore.years":`年`,
"label.appstore.product":`製品`,
"label.appstore.payHistory":`支払い履歴`,
"label.appstore.addUser":`ユーザー追加`,
"label.appstore.city":`都市`,
"label.appstore.Discount.months":`20ヶ月割引`,
"label.appstore.duration":`期間`,
"label.appstore.OrderDuration":`注文期間`,
"label.appstore.selectState":`都道府県を選択してください`,
"label.appstore.enterEmail":`メールを入力してください`,
"label.appstore.Description.text":`説明テキスト`,
"label.appstore.startdate":`開始日`,
"label.appstore.Subscription":`支払い済み`,
"label.appstore.payment":`支払い`,
"label.appstore.enter.phone":`電話番号を入力してください`,
"label.appstore.VerificationCode":`カード確認コード`,
"label.appstore.updated.success":`更新成功`,
"label.appstore.invoicedate":`請求書日付`,
"label.appstore.PurchaseDetails":`購入詳細`,
"label.appstore.Pro.rata.amount":`比例金額`,
"label.appstore.countrys":`国/地域`,
"label.appstore.Due.date":`支払期日`,
"label.appstore.Four.part.order":`4ステップでCloudCCを注文`,
"label.appstore.Order.succeeded":`注文が成功しました`,
"label.appstore.enter.company.name":`会社名を入力してください`,
"label.appstore.shipto":`配送先住所`,
"label.appstore.tabpage.ok":`OK`,
"label.appstore.Select.country":`国/地域を選択してください`,
"label.appstore.OrderingCenter":`注文センター`,
"label.appstore.usernumber":`ユーザー数`,
"label.appstore.enterPhone":`電話番号を入力してください`,
"label.appstore.sales.pricing.issues":`販売・価格問題`,
"label.appstore.Transaction.history":`取引履歴`,
"label.appstore.download.invoice":`請求書ダウンロード`,
"label.appstore.please.fill.state":`州/県を入力してください`,
"label.appstore.addAccount":`アカウント追加`,
"label.appstore.user.number.price":`ユーザー数価格`,
"label.appstore.Billing.address":`請求先住所`,
"label.appstore.Billing.address.same":`請求先住所と同じ`,
"label.appstore.Billing.address.different":`請求先住所と異なる`,
"label.appstore.Billing.address.new":`新しい請求先住所`,
"label.appstore.Billing.address.edit":`請求先住所編集`,
"label.appstore.Billing.address.delete":`請求先住所削除`,
"label.appstore.Billing.address.default":`デフォルト請求先住所`,
"label.appstore.Billing.address.select":`請求先住所選択`,
"label.appstore.Billing.address.add":`請求先住所追加`,
"label.appstore.Billing.address.update":`請求先住所更新`,
"label.appstore.Billing.address.save":`請求先住所保存`,
"label.appstore.Billing.address.cancel":`請求先住所キャンセル`,
"label.appstore.Billing.address.required":`請求先住所は必須です`,
"label.appstore.Billing.address.invalid":`無効な請求先住所`,
"label.appstore.Billing.address.success":`請求先住所が正常に保存されました`,
"label.appstore.Billing.address.error":`請求先住所の保存に失敗しました`,
"label.appstore.contact.us":`お問い合わせ`,
"label.appstore.visit":`CloudCCを訪問`,
"label.appstore.Purchased.products":`購入済み製品`,
"label.appstore.amounttt":`金額は比例計算されます`,
"label.appstore.please.enter.cardcode":`クレジットカードコードを入力してください。`,
"label.appstore.SeveralDays":`{0}日`,
"label.appstore.End.trial":`30日間の試用期間が終了しました。現在、アカウントデータは15日間保持され、購入後に簡単に復元できます。`,
"label.appstore.email":`メール`,
"label.appstore.Quantity.used":`使用済みライセンス`,
"label.appstore.card.number":`カード番号`,
"label.appstore.phone":`電話`,
"label.appstore.Offline.payment":`オフライン支払い`,
"label.appstore.showFeatures":`機能・アドオンを表示`,
"label.appstore.contact.email":`support@cloudcc.com`,
"label.appstore.Thank.choice":`CloudCCをお選びいただきありがとうございます`,
"label.appstore.continue.agree":`続行することで、当社の`,
"label.appstore.Discount":`割引`,
"label.appstore.Welcome.useCloudcc":`CloudCCストアへようこそ！`,
"label.appstore.Operation.succeeded":`操作成功`,
"label.appstore.No.view.permission":`このページを表示する必要なアクセス権限がありません。アクセスが必要な場合は、レコード所有者または管理者にお問い合わせください。`,
"label.appmarket.officialaddress":`住所`,
"label.appmarket.free":`無料`,
"label.appmarket.human":`人事`,
"label.appmarket.mobileterminal":`モバイル対応`,
"label.appstore.password":`パスワード`,
"label.appstore.Please.enter.reason.extend":`試用延長の理由を入力してください`,
"label.appmarket.allversions":`全エディション`,
"label.appmarket.make":`製造`,
"label.appmarket.placeselect":`選択`,
"label.appmarket.ContactEmail":`メール`,
"label.appstore.Cancel.trial":`試用キャンセル`,
"label.appmarket.Contact Number":`電話`,
"label.appmarket.morepackage":`開発者はより多くのパッケージを提供しています。`,
"label.appmarket.comment":`レビュー`,
"label.appmarket.partner":`パートナー部門`,
"label.appmarket.professional":`プロフェッショナル`,
"label.appmarket.cooperativepartner":`パートナー`,
"label.appmarket.other":`その他`,
"label.appstore.Cancellation.reason":`キャンセル理由`,
"label.appmarket.automobile":`自動車保険`,
"label.appstore.Please.enter.reason.canceling":`試用キャンセルの理由を入力してください`,
"label.appmarket.crm":`新しいCloudCC CRMエコロジー`,
"label.appstore.length":`7〜11文字の長さ`,
"label.appmarket.appstore":`アプリストア`,
"label.appstore.AreYouSure.cancel.account":`CloudCCアカウントをキャンセルしてもよろしいですか？`,
"label.appmarket.IT":`IT`,
"label.appmarket.edu":`教育`,
"label.appstore.version.enterprise":`ENTERPRISE +`,
"label.appstore.Extended.use":`試用延長`,
"label.appmarket.launchtime":`リリース日`,
"label.appmarket.medical":`医療`,
"label.appmarket.pay":`有料`,
"label.appmarket.solution":`ソリューション`,
"label.appmarket.eliminate":`クリア`,
"label.appmarket.allprices":`全プラン`,
"label.appstore.Extended.trial":`試用延長`,
"label.appmarket.lastrelease":`最新`,
"label.appstore.website.aboutus.officecall":`電話：`,
"label.appmarket.office":`オフィスクラウド`,
"label.appmarket.setuptime":`設立日`,
"label.appstore.expired2":`試用期間が終了しました`,
"label.appstore.extensionSuccess":`おめでとうございます！試用期間が15日延長されました。ホームページにリダイレクトされます。`,
"label.appstore.Upgrade.payment":`試用期間中に機能を十分に体験していただけたことを願っています。CloudCCを継続してご利用いただくには、有料版にアップグレードしてください。`,
"label.appmarket.viewall":`すべて表示`,
"label.appmarket.market":`マーケティングクラウド`,
"label.appmarket.unlimited":`無制限`,
"label.appmarket.versionno":`ビルド番号`,
"label.appmarket.industry":`業界`,
"label.appstore.Cancel.account":`この操作によりCloudCCアカウントがキャンセルされ、既存のCloudCCデータは無料版CRMアプリケーションに移行されます。`,
"label.appmarket.sales":`セールスクラウド`,
"label.appmarket.apply":`申請`,
"label.appmarket.packagecontent":`パッケージ内容`,
"label.appstore.CancelCC":`CloudCCアカウントをキャンセル`,
"label.appstore.Please.enter.password":`パスワードを入力してください`,
"label.appstore.experience":`CloudCCでの体験をお聞かせください。試用期間を15日延長いたします。`,
"label.appstore.version.free":`BASIC +`,
"label.appstore.least.one":`CloudCC管理者として少なくとも1つのライセンスを購入してください。`,
"label.appmarket.allratings":`すべて表示`,
"label.appstore.Dont.continue":`CloudCCの使用を継続したくありませんか？`,
"label.appmarket.finance":`金融`,
"label.appmarket.applications":`アプリケーション`,
"label.appstore.time.expand":`これらの機能を探索するためにもっと時間が必要ですか？`,
"label.appmarket.computerterminal":`Web対応`,
"label.appmarket.obtain":`取得`,
"label.appmarket.components":`コンポーネント`,
"label.appstore.actualDuration":`割引後の月数`,
"label.appmarket.score":`評価`,
"label.appmarket.service":`サービスクラウド`,
"label.appmarket.for":`適用先`,
"label.appmarket.project":`プロジェクト管理`,
"label.appstore.Storetitle":`CloudCCストア`,
"label.appmarket.summary":`概要`,
"label.appstore.version.professional":`PROFESSIONAL +`,
"label.appstore.three.part.order":`3つの簡単なステップでCloudCCを購入`,
"resource.industry.logistics": `物流業界`,
"personal.tab.basic.info": "基本情報",
"personal.tab.account.info": "アカウント情報",
"personal.tab.my.company": "マイ会社",
"personal.edit": "編集",
"personal.new.company": "新しい会社",
"personal.current.company": "現在の会社",
"personal.field.avatar": "アバター",
"personal.field.name": "名前",
"personal.field.qq": "QQ番号",
"personal.field.wechat": "WeChat",
"personal.field.phone": "連絡先",
"personal.field.region": "地域",
"personal.field.company.size": "会社規模",
"personal.field.industry": "業界",
"personal.field.title": "役職",
"personal.field.num.of.users": "ユーザー数",
"personal.field.launch.date": "予定開始日",
"personal.field.pain.point": "課題",
"personal.field.budget": "予算",
"personal.field.language": "言語",
"personal.field.login.account": "ログインアカウント",
"personal.field.password": "パスワード",
"personal.field.mobile": "携帯電話",
"personal.field.email": "メール",
"personal.company.size.less.than.20": "20人未満",
"personal.company.size.21.100": "21-100人",
"personal.company.size.101.500": "101-500人",
"personal.company.size.501.1000": "501-1000人",
"personal.company.size.more.than.1000": "1000人以上",
"personal.title.sales.manager": "営業マネージャー",
"personal.title.marketing.hr.manager": "マーケティング/人事マネージャー",
"personal.title.customer.service.manager": "カスタマーサービスマネージャー",
"personal.title.general.manager": "ゼネラルマネージャー",
"personal.title.it.manager": "ITマネージャー",
"personal.title.operations.manager": "オペレーションマネージャー",
"personal.title.other": "その他",
"personal.edit.basic.info": "基本情報を整える",
"personal.cancel": "キャンセル",
"personal.save": "保存",
"personal.placeholder.name": "名前を入力してください",
"personal.placeholder.qq": "QQ番号を入力してください",
"personal.placeholder.wechat": "WeChatを入力してください",
"personal.placeholder.phone": "連絡先を入力してください",
"personal.placeholder.region": "都道府県/市/区を選択してください",
"personal.placeholder.company.size": "会社規模を選択してください",
"personal.placeholder.industry": "業界を入力してください",
"personal.placeholder.title": "役職を選択してください",
"personal.placeholder.num.of.users": "予定CRMユーザー数を入力してください",
"personal.placeholder.launch.date": "開始日を選択してください",
"personal.placeholder.pain.point": "課題を入力してください（任意）",
"personal.placeholder.budget": "予算を入力してください（任意）",
"personal.validation.avatar.required": "アバターをアップロードしてください",
"personal.validation.name.required": "名前を入力してください",
"personal.validation.phone.required": "連絡先を入力してください",
"personal.validation.region.required": "地域を選択してください",
"personal.validation.company.size.required": "会社規模を選択してください",
"personal.validation.industry.required": "業界を入力してください",
"personal.validation.title.required": "役職を選択してください",
"personal.validation.num.of.users.required": "ユーザー数を入力してください",
"personal.validation.launch.date.required": "予定開始日を選択してください",
"personal.message.save.success": "基本情報が正常に保存されました",
"personal.message.save.failed": "保存に失敗しました。再試行してください",
"personal.message.complete.required": "必須情報を入力してください",

// アバター関連
"personal.avatar.title": "個人アバター",
"personal.avatar.description": "個人アバターをアップロード、JPG、PNG、GIF形式をサポート、ファイルサイズは5MB以下",
"personal.avatar.upload": "アバターアップロード",
"personal.avatar.uploading": "アップロード中...",
"personal.avatar.remove": "アバター削除",
"personal.avatar.remove.title": "削除確認",
"personal.avatar.remove.confirm": "現在のアバターを削除してもよろしいですか？",
"personal.avatar.remove.success": "アバターが正常に削除されました",
"personal.avatar.upload.success": "アバターが正常にアップロードされました",
"personal.avatar.upload.failed": "アバターアップロードに失敗しました",
"personal.avatar.error.invalid.type": "JPG、PNG、GIF形式の画像を選択してください",
"personal.avatar.error.too.large": "画像サイズは5MBを超えることはできません",
"personal.avatar.tips": "JPG、PNG、GIF形式をサポート、ファイルサイズは5MB以下",
"personal.confirm": "確認",
"personal.modify.mobile.title": "携帯電話変更",
"personal.modify.email.title": "メール変更",
"personal.placeholder.mobile": "携帯電話番号を入力してください",
"personal.placeholder.email": "メールを入力してください",
"personal.validation.mobile.required": "携帯電話番号を入力してください",
"personal.validation.email.required": "メールを入力してください",
"personal.validation.mobile.format": "有効な携帯電話番号を入力してください",
"personal.validation.email.format": "有効なメールを入力してください",
"personal.message.mobile.save.success": "携帯電話番号が正常に更新されました",
"personal.message.email.save.success": "メールが正常に更新されました",
"personal.message.mobile.duplicate": "携帯電話番号は既に使用されています。別の番号を使用してください",
"personal.message.complete.info": "情報を入力してください",
"personal.modify.password.title": "パスワード変更",
"personal.field.old.password": "現在のパスワード",
"personal.field.new.password": "新しいパスワード",
"personal.field.confirm.password": "パスワード確認",
"personal.placeholder.old.password": "現在のパスワードを入力してください",
"personal.placeholder.new.password": "新しいパスワードを入力してください",
"personal.placeholder.confirm.password": "新しいパスワードを確認してください",
"personal.validation.old.password.required": "現在のパスワードを入力してください",
"personal.validation.new.password.required": "新しいパスワードを入力してください",
"personal.validation.confirm.password.required": "パスワード確認を入力してください",
"personal.validation.password.length": "パスワードは6-20文字である必要があります",
"personal.validation.password.mismatch": "パスワードが一致しません",
"personal.message.password.save.success": "パスワードが正常に更新されました",
"personal.message.password.save.failed": "パスワード更新に失敗しました。再試行してください",
"allApps.add.filter":`フィルター追加`,
"allApps.show.results.filter":`{0}件の結果を表示、フィルター条件`,
"allApps.search.filter.placeholder":`フィルターを検索...`,
"applist.all.results":`すべての結果`,
"resource.error.get.user.info": "ユーザー情報の取得に失敗しました",
"resource.warning.get.user.info.tips": "ユーザー情報を取得できませんでした。ページを再読み込みしてください。",
"resource.app.store.title": `個人センター`,
"resource.success": `成功`,
"resource.success.demo.apply": `申請が成功しました。後でパートナーがデモを実施します。`,
"label.account.reg.fail.msg":`登録に失敗しました。後で再試行してください。`,
// ルートタイトル
"route.title.home":`ホーム`,
"route.title.industry.mall":`業界モール`,
"route.title.app.detail":`アプリ詳細`,
"route.title.my.apps":`マイアプリ`,
"route.title.my.apps.detail":`マイアプリ詳細`,
"route.title.partnership":`パートナーシップ`,
"route.title.invoice.management":`請求書管理`,
"route.title.create.invoice":`請求書作成`,
"route.title.invoice.detail":`請求書詳細`,
"route.title.personal.center":`個人センター`,
"route.title.app.list":`アプリリスト`,
"route.title.page.not.found":`ページが見つかりません`,
"resource.industry.ecommerce":`電子商取引`,
"resource.industry.system.integration":`システム統合`,
  // Trial ページ
  "trial.page.title": "試用を開始",
  "trial.step1": "ステップ1",
  "trial.step2": "ステップ2",
  "trial.step1.title": "以下の機能を試用します",
  "trial.features.experience": "テスト環境で体験",
  "trial.features.full.solution": "完全なビジネスソリューション",
  "trial.features.powerful.paas": "強力なPaaSプラットフォーム機能",
  "trial.features.build.app": "自分のアプリを作成",
  "trial.features.experience.crm": "体驗CRMシステム",
  "trial.features.experience.portal": "体驗客戶門戶",
  "customer.portal.crm.integration": "客戶門戶與CRM數據打通",
  "industry.portal.mall": "符合業界的客戶門戶或商城",
  "fully.integrated.crm": "與CRM完全打通",
  "customizable.details": "可根據細節再定制",
  "trial.cta.experience.now": "體驗現在",
  "trial.step2.title": "連絡先情報を共有",
  "trial.step2.helper": "連絡先を入力してください。送信後、AIが試用環境を開設します。継続利用のため、3日以内にメールを確認し初期パスワードを変更してください。変更がない場合、AIは環境を回収します。",
  "trial.form.first.name": "名",
  "trial.form.last.name": "姓",
  "trial.form.email": "メール",
  "trial.form.email.placeholder": "必須、アカウントとパスワードを受け取るために使用されます",
  "trial.form.company": "会社",
  "trial.form.title": "職務",
  "trial.form.staff": "従業員",
  "trial.form.phone": "携帯電話",
  "trial.form.country.region": "国/地域",
  "trial.form.agree.privacy": "フォーム送信により、CloudCCのプライバシーポリシーに同意し、内容を確認したものとみなします",
  "trial.form.agree.prefix": "フォーム送信により、同意し内容を確認したものとみなします",
  "label.account.pleaseAgree": "利用規約とプライバシーポリシーに同意してください",
  "trial.contact.website": "ウェブサイト",
  "trial.contact.email": "メール",
  "trial.contact.phone": "電話",
  "trial.cta": "試用を申し込む",
  "email.check.verification.code": "メールで認証コードをご確認ください",
  "email.send.verification.code": "認証コードを送信",
  "email.fill.verification.code": "メール認証コードを入力してください",
  "email.verification.sent": "認証コードを送信しました。メールをご確認ください",
  "email.resend.after.seconds": "再送({0}秒)",
  "email.verification.send.failed": "認証コードの送信に失敗しました。再試行してください",
  "trial.disclaimer": "CloudCCは本ソリューションの提供者ではありませんが、限定的なセキュリティ審査を行っています。",
  "label.account.please.enter.name": "姓を入力してください",
  "label.account.username.enter": "名を入力してください",
  "label.account.enter.Emailbox": "メールアドレスを入力してください",
  "label.account.batchadd.newbatchpage.save.em": "メール形式が正しくありません",
  "label.account.Company.name": "会社名を入力してください",
  "label.account.fillMobile": "電話番号を入力してください",
  "label.account.only.Numbers": "数字のみ入力できます",
  "label.account.phone.length": "電話番号は少なくとも7桁である必要があります",
  "label.account.reg.phone.already": "この電話番号はこの会社で既に登録されています",
  "label.account.Select.job": "職務を選択してください",
  "label.account.Select.staff": "従業員数を選択してください",
  "label.account.Select.country": "国/地域を選択してください",
  "personal.placeholder.language": "言語を選択してください",
}